/**
 * The core entity type names, as a literal. Kept apart from the schema map in `index.ts` so code that only
 * needs the names (`entityTypeNames`, the element lists) does not bundle every entity schema (GH #2294).
 * `entity-names.test.ts` checks it against the map.
 */
export const coreEntityNames = [
  'folder',
  'audio',
  'page',
  'profile',
  'image',
  'entitylink',
  'chat',
  'todo',
  'comment',
  'video',
  'pdf',
  'note',
  'table',
  'link',
  'tr',
  'th',
  'td',
  'thead',
  'tbody',
  'ref',
  'searchfolder',
] as const

export type CoreEntityName = (typeof coreEntityNames)[number]
